// @flow
export const TRAINING_MODULES_MODULE_NAME: 'trainingModules' = 'trainingModules';
export const TRAINING_MODULES_ACTION_TYPES = {
    GET_GAME_MODULES: 'TRAINING_MODULES__GET_GAME_MODULES',
    GET_GAME_MODULES_CHAPTERS: 'GET_GAME_MODULES_CHAPTERS',
    SET_GAME_MODULE_SESSION: 'TRAINING_MODULES__SET_GAME_MODULE_SESSION',
};
export const TYPES_MODULES: {
    COMPLETED: 3,
    NOT_STARTED: 1,
    STARTED: 2,
} = {
    COMPLETED: 3,
    NOT_STARTED: 1,
    STARTED: 2,
};

export const NOTIFICATIONS_MODULES: {
    NO_FINISHED_MODULE: 2,
    NO_LICENSE: 1,
} = {
    NO_FINISHED_MODULE: 2,
    NO_LICENSE: 1,
};
